import { render } from "./multipleChoice.vue?vue&type=template&id=0bdd759c&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"

import "./multipleChoice.vue?vue&type=style&index=0&id=0bdd759c&lang=scss"
import "./multipleChoice.vue?vue&type=style&index=1&id=0bdd759c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdd759c"]])

export default __exports__